import { Box, BoxProps, ColorOptions, Text, TextProps } from '@jfs/ui-new'
import { TextInputNew } from '../AdminInputs'
import React, { forwardRef, useState } from 'react'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { toIsoDate } from '../../utils'

const CustomDatePickerInput = forwardRef(
  (
    {
      value,
      onClick,
      label,
      labelFontFamily,
      labelColor,
      labelPaddingBottom,
      error,
      touched: initialTouched,
      rightComponent,
      labelFontSize = 14,
      paddingVertical,
      hint,
      disabled,
      borderColor = '#d1d3e2' as ColorOptions,
      bgColor = 'WHITE',
      paddingHorizontal = 16,
      errorColor,
    }: any,
    ref,
  ) => {
    console.log('placeholder=', hint)
    const [touched, setTouched] = useState(initialTouched)
    return (
      <div className="customDatePickerInput" onClick={onClick} ref={ref}>
        <TextInputNew
          onPressIn={onClick}
          value={value}
          label={label}
          onFocusBorderWidth={1}
          color={'BLACK_21' as ColorOptions}
          paddingHorizontal={paddingHorizontal}
          selectionColor={'BLUE'}
          paddingVertical={paddingVertical}
          type="body12"
          borderColor={borderColor}
          borderRadius={4}
          fontSize={12}
          labelFontFamily={labelFontFamily}
          labelColor={labelColor}
          labelFontSize={labelFontSize}
          touched={touched}
          onBlur={() => !touched && setTouched(true)}
          labelPaddingBottom={labelPaddingBottom}
          rightComponent={rightComponent}
          error={error}
          errorColor={errorColor}
          placeholder={hint}
          editable={!disabled}
          disabled={disabled}
          bgColor={bgColor}
        />
      </div>
    )
  },
)

const isDate = function (date: string) {
  return new Date(date).toString() !== 'Invalid Date'
}

const DatePickerReact = ({
  label,
  labelPaddingBottom = 10,
  labelFontFamily = 'jiotype-bold',
  labelFontSize = 12,
  labelColor = '#757575',
  timeInputLabel,
  dateFormat = 'dd-MM-yyyy',
  showTimeInput,
  setFieldValue,
  fieldName,
  maxDate = new Date(),
  value,
  minDate = new Date('1900-01-01'),
  touched,
  error,
  errorColor,
  from = '',
  rightComponent = undefined,
  showYearDropdown = false,
  showMonthDropdown = false,
  scrollableYearDropdown = false,
  disabled = false,
  showMonthYearDropdown = false,
  dropdownMode = undefined,
  paddingVertical = 9,
  placeholder,
  shouldCloseOnSelect = false,
  borderColor,
  bgColor,
  paddingHorizontal,
}: any) => {
  const convertedDate = value === '' || !isDate(value) ? undefined : new Date(value)

  const datePickerRef = React.useRef(null)

  const onChangeHandle = (val: Date) => {
    if (setFieldValue && fieldName && val) {
      setFieldValue(fieldName, showTimeInput ? (from === 'ess' ? new Date(val)?.getTime() : val) : toIsoDate(val))
    }
  }

  return (
    <Box {...styles.container}>
      <DatePicker
        onChange={onChangeHandle}
        selected={convertedDate}
        dateFormat={dateFormat}
        timeInputLabel={timeInputLabel}
        showTimeInput={showTimeInput}
        portalId="modal-root"
        ref={datePickerRef}
        shouldCloseOnSelect={shouldCloseOnSelect}
        maxDate={maxDate}
        minDate={minDate}
        yearDropdownItemNumber={100}
        showYearDropdown={showYearDropdown}
        showMonthDropdown={showMonthDropdown}
        scrollableYearDropdown={scrollableYearDropdown}
        showMonthYearDropdown={showMonthYearDropdown}
        dropdownMode={dropdownMode}
        disabled={disabled}
        customInput={
          <CustomDatePickerInput
            label={label}
            labelPaddingBottom={labelPaddingBottom}
            labelFontFamily={labelFontFamily}
            labelFontSize={labelFontSize}
            labelColor={labelColor}
            value={value}
            touched={touched}
            error={error}
            errorColor={errorColor}
            rightComponent={rightComponent}
            paddingVertical={paddingVertical}
            hint={placeholder}
            disabled={disabled}
            borderColor={borderColor}
            bgColor={bgColor}
            paddingHorizontal={paddingHorizontal}
          />
        }>
        <Box {...styles.buttonContainer}>
          <Box
            {...styles.button}
            onPress={() => {
              console.log('datePickerRef?.current?.props?.selected', datePickerRef?.current?.props?.selected)
              onChangeHandle(datePickerRef?.current?.props?.selected)
              datePickerRef.current.setOpen(false)
            }}>
            <Text {...styles.buttonText}>OK</Text>
          </Box>
        </Box>
      </DatePicker>
    </Box>
  )
}

export { DatePickerReact }

const styles = {
  container: {
    w: '100%',
  } as BoxProps,
  buttonContainer: {
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'center',
  } as BoxProps,
  button: {
    p: 5,
    width: 50,
    borderRadius: 40,
    alignItems: 'center',
    backgroundColor: 'PRIMARY',
  } as BoxProps,
  buttonText: {
    color: 'WHITE',
  } as TextProps,
  error: {
    color: 'RED',
    fontSize: 12,
  } as TextProps,
}
